<div class="input-with-flag" [formGroup]="parentForm">
  <div class="flag-input">
    <mat-form-field>
      <mat-label>{{label}}</mat-label>
      <span matPrefix>&nbsp;</span>
      <input matInput [disabled]="isDisabled" style="width:82%" type="text" maxlength=18 placeholder="+1(555)555-1234" [value]="value" (keyup)="changeEvent($event)" (keypress)="restrictAlphabets($event)" [formControlName]="formFieldName">
    </mat-form-field>
    <div class="flag-selector">
      <mat-select (selectionChange)='onSelectedOption($event)' [compareWith]="compareFunction" [disabled]="isDisabled">
        <mat-option *ngFor="let item of countries; let i = index" [value]="i">
          <div class="flag-image" [style.background-position-x.px]="-i*28"></div>
          <div class="flag-text">{{ item.name }} {{item.prefix}} </div>
        </mat-option>
      </mat-select>
      <div class="selected-flag-image" [style.background-position-x.px]="-selectedIndex*28"></div>
    </div>
  </div>


</div>